import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

import {API_ENDPOINT, APP_URL, APP_NAME, admin_phone, toast_anim , IMG_URL , amount_format , LIMIT} from '../config/Common'
import {Links} from '../../routes/PathLink'
import ProductCard from '../../cards/ProductCard'
import InfiniteScroll from "react-infinite-scroll-component";
import { Loading  , Bucket} from "../../custom-icons";
import { LazyLoadImage, LazyLoadComponent } from 'react-lazy-load-image-component';
import SavePriceInd from '../../ui/SavePriceInd'

const galleryCarouselBreakpoints = {
   320: {
     slidesPerView: 1,
   },
   480: {
     slidesPerView: 2,
   },
   640: {
     slidesPerView: 3,
   },
   
  };



const ListNonFeaturedProducts = (props) => {
   const [products,setProducts] = useState([]);
   const [loading, setLoading] = useState(false);
   const [hasMore, setHasMore] = useState(false);
   const [user_type ,setUserType] = useState(localStorage.getItem('user_type'));
   const [totalRec, setTotalRec] = useState(0)
   const [page, setPage] = useState(1);

    useEffect(() => {      
      getnonfeaturedProduct(1);
   },[])


    const getnonfeaturedProduct = (pg) => {
     

      let paginate = `page=${pg}&limit=${LIMIT}`;
      

      fetch(`${API_ENDPOINT}/get_nonfeaturedproducts_front?${paginate}`,{
         method: 'GET',
         headers : {        
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
         }
      }).then(function (response) {
            return response.json();
      }).then( (result)=> {
         console.log('cat products======',result)
         //setProducts(result.data)
         if(pg === 1){
            setProducts(result.data)
         }else{
            setProducts([...products, ...result.data])
         }
         let nextPage = page + 1;
         setPage(nextPage)
         setTotalRec(result.total)

         if(result.data.length < LIMIT){
            setHasMore(false)
         }else{
            setHasMore(true)
         }

       
         
         /* let p = document.getElementById('product-list')
         p.scrollIntoView( { behavior: 'smooth', block: 'start' } ); */
      })
   }


   const fetchData = () => {
      getnonfeaturedProduct(page)
   }

   return(<div className="py-2">
      {products &&  
      <InfiniteScroll
      dataLength={products.length} //This is important field to render the next data
      next={fetchData}
      hasMore={hasMore}
      loader={
         <h4 className="h-20 mt-5"><Loading className="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-assent-600 inline" />Loading...</h4>
      }                    
      scrollThreshold={0.7}
      >
      <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-3">
      {
        products.map((item, key) => (
         <Link to={`${Links.PRODUCT}/${item.product_slug}`} key={`product-${item.p_id}`}>
            <article className="product-card cart-type-krypton h-full cursor-pointer overflow-hidden rounded border border-border-200 bg-light transition-shadow duration-200 hover:shadow-sm dark:bg-gray-700 dark:border-none">
               <div className="relative flex h-48 w-auto items-center justify-center sm:h-64">
                   <div className="absolute top-3 flex gap-2">
                     {item.is_featured == 1 && 
                        <div class=" rounded bg-yellow-500 px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Featured</div>
                     }
                     {item.is_upcoming == 1 && 
                        <div class="rounded bg-[#00A09D] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Upcoming</div>
                     }
                     {
                     item.is_popular == 1 && 
                     <div class=" rounded bg-[#7D87D4] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Popular</div>
                     }
                     {
                     item.is_verified == 1 && 
                     <div class="rounded bg-[#8D9557] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Verified</div>
                     }
                   </div>
                  {
                  item.availability_status && item.availability_status !== 'available' ?
                  <div class="absolute bg-dark text-center text-light w-full bg-opacity-50 text-md py-3 capitalize h-full flex items-center justify-center">
                  <span className={"bg-red-100 text-red-800 border-red-400 text-md font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border capitalize"}>{item.availability_status}</span>
                  </div>
                  :null
                  }
                  
                  {
                     item.product_image
                     ?
                     <LazyLoadImage src={`${IMG_URL}${item.product_image}`} className="h-48 w-full sm:h-64 object-cover" alt={item.product_name} sizes="100vw" />
                     :
                     <LazyLoadImage src={`${APP_URL}/img/no-image-available.png`} alt={item.product_name} sizes="100vw" />
                  }                                
                  

                  
               </div>

               <header className="relative p-3 md:p-5 md:py-6">
                  <h3 role="button" className="mb-2 truncate text-sm font-semibold text-heading dark:text-zinc-400">{item.product_name}</h3>
                  
                  <div className="relative mt-7 flex min-h-6 items-center justify-between md:mt-8">
                     {
                        //let item.price.toLocaleString()
                     <div className="relative">
                        
                        {user_type == 'dealer' && item.dealer_price &&  item.dealer_price > 0 ?
                           (<span className="text-sm font-semibold text-accent md:text-base flex items-center">
                           {amount_format(item.dealer_price)}
                           </span>)
                           :
                           (<>
                           {item.warranty_price && item.warranty_price > 0 ?
                            <><span className="text-sm font-semibold text-accent md:text-base flex items-center">
                           {amount_format(item.warranty_price)}
                           </span>
                           {user_type != 'dealer' &&
                            <SavePriceInd max={item.sale_price} min={item.warranty_price} />
                           }
                           </>
                           :
                           <>
                           {item.dealer_price && item.dealer_price > 0 ?
                           <><span className="text-sm font-semibold text-accent md:text-base flex items-center">
                              {amount_format(item.dealer_price)}
                           </span>
                           {user_type != 'dealer' &&
                            <SavePriceInd max={item.sale_price} min={item.dealer_price} />
                           }
                           </>
                           :
                            <><span className="text-sm font-semibold text-accent md:text-base flex items-center">
                              {amount_format(item.price)}
                           </span>
                            {user_type != 'dealer' &&
                            <SavePriceInd max={item.sale_price} min={item.price} />
                           }
                           </>
                           }
                           </>
                           }
                        </>
                        )
                        
                        }
                     </div>
                     }
                     {
                        item.is_upcoming == 1 ?
                     (null)
                     :
                     (<button className="order-5 flex items-center justify-center rounded-full border-2 border-border-100 bg-light dark:bg-gray-800 dark:border-gray-600 px-3 py-2 text-sm font-semibold text-accent transition-colors duration-300 hover:border-accent hover:bg-accent hover:text-light focus:border-accent focus:bg-accent focus:text-light focus:outline-none sm:order-4 sm:justify-start sm:px-5 dark:hover:bg-accent dark:hover:border-accent">
                        <span className="h-4 w-4 ltr:mr-2.5 rtl:ml-2.5"><Bucket /></span>
                        <span>Cart</span>
                     </button>)
                     }
                  </div>
               </header>
            </article>
         </Link>
         ))

      }
      </div>
      </InfiniteScroll> 
      }     
   </div>)
}

export default ListNonFeaturedProducts;